<template lang="pug">
  font-awesome-icon.medium-icon(v-if="iconType !== ''", :icon="iconType", :size="fontAwasomeIconSize")
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faVideo, faImage, faFolder, faFolderOpen, faDesktop, faUniversity } from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    FontAwesomeIcon
  },
  created () {
    library.add(faVideo, faImage, faFolder, faFolderOpen, faDesktop, faUniversity)
  },
  props: {
    'medium': {
      required: true
    },
    'size': {
      required: false
    }
  },
  data () {
    return {
      errors: {
      }
    }
  },
  computed: {
    iconType () {
      if (!this.medium || !this.medium.hasOwnProperty('type')) {
        console.error('MediumIcon: wrong medium object: ' + JSON.stringify(this.medium))
        return ''
      }
      switch (this.medium.type) {
        case 'Video':
          return 'video'
        case 'Audio':
          return 'headphones-alt'
        case 'Image':
          return 'image'
        case 'PlayList':
          return 'film'
        case 'PlayListDesktop':
          return 'desktop'
        case 'PlayListLayout':
          return 'layer-group'
        case 'PlayListLibrary':
          return 'university'
        case 'PlayListLibraryRoot':
          return 'th'
        case 'PlayListLibraryFolder':
          return 'folder'
        case 'PlayListUnassigned':
          return 'unlink'
        case 'HTML5app':
          return 'code'
        case 'HTMLzip':
          return 'file-archive'
        case 'PlayListExtended':
          return 'camera-retro'
        case 'Custom':
          return 'file'
      }
      console.error('MediumIcon: unknown medium type: ' + this.medium.type)
      return ''
    },
    fontAwasomeIconSize () {
      let returnValue = 'lg'
      switch (this.size) {
        case 'large':
          returnValue = 'lg'
          break
        case 'normal':
          returnValue = ''
          break
        case 'small':
          returnValue = 'sm'
          break
        case 'mini':
          returnValue = 'xs'
          break
      }
      return returnValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/MediumIcon.vue